import { render, staticRenderFns } from "./SubMa.vue?vue&type=template&id=1960662b&scoped=true&"
import script from "./SubMa.vue?vue&type=script&lang=js&"
export * from "./SubMa.vue?vue&type=script&lang=js&"
import style0 from "./SubMa.vue?vue&type=style&index=0&id=1960662b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960662b",
  null
  
)

export default component.exports